import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../Environments/Environment";
import { Permission } from "../Dto/PermissionModel";

@Injectable({ providedIn: "root" })
export class PermissionApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.adminServiceUrl;

  async fetchPermissions(): Promise<Permission[]> {
    const url = new URL("permissions", `${this.baseUrl}/`);
    return await firstValueFrom(this.http.get<Permission[]>(url.toString(), { withCredentials: true }));
  }
}
